import styled from 'styled-components';

export const StyledNavLoaderItem = styled.div`
  height: 32px;
  border-radius: 6px;
  & > div {
    width: 100%;
    height: 100%;
  }
`;

export const loaderStyle = {
  height: '100%',
  width: '100%',
};
